var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditMediaCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 116,
  height: 96
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "editMediaCopy_svg__a",
  x1: 21.59,
  x2: 110.41,
  y1: 11.59,
  y2: 100.41,
  "data-name": "New Gradient Swatch 5",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#editMediaCopy_svg__a",
  id: "editMediaCopy_svg__b",
  x1: 87.06,
  x2: 108.06,
  y1: 46.47,
  y2: 46.47
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1",
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.3
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M98 0H2a2 2 0 0 0-2 2v76a2 2 0 0 0 2 2h96a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M68 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H69a1 1 0 0 1-1-1ZM52 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H53a1 1 0 0 1-1-1ZM36 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H37a1 1 0 0 1-1-1ZM20 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1ZM4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm12 70a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H37a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H53a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H69a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H85a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm0-64a1 1 0 0 1-1 1H85a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z",
  style: {
    fill: "#7ca5cc"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M4 16h92v48H4z",
  style: {
    fill: "#7ca5cc",
    opacity: 0.2,
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M114 16H18a2 2 0 0 0-2 2v76a2 2 0 0 0 2 2h96a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2m-30 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H85a1 1 0 0 1-1-1Zm-16 0a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H69a1 1 0 0 1-1-1Zm-16 0a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H53a1 1 0 0 1-1-1Zm-16 0a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H37a1 1 0 0 1-1-1Zm-16 0a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1Zm12 70a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H37a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H53a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H69a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1H85a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm16 0a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm0-64a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z",
  style: {
    fill: "url(#editMediaCopy_svg__a)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 48,
  x: 20,
  y: 32,
  rx: 1,
  style: {
    opacity: 0.2,
    mixBlendMode: "multiply",
    fill: "#193138"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 66.76V79a1 1 0 0 0 1 1h90a1 1 0 0 0 1-1V66.76a22.9 22.9 0 0 1-6.94 4.24c-18.25 6.92-34.28-15.59-58-15-6.34.13-15.72 2-27.06 10.76",
  style: {
    mixBlendMode: "multiply",
    fill: "#193138",
    opacity: 0.1
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97.56,
  cy: 46.47,
  r: 10.5,
  style: {
    opacity: 0.2,
    mixBlendMode: "multiply",
    fill: "url(#editMediaCopy_svg__b)"
  }
})));
export default SvgEditMediaCopy;